(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ac-country-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = async () => {
      const source = document.getElementById('ac-country-gate-template');
      if (!source || window.Shopify?.designMode) return;

      const denied = new Set([
        'IN', 'BD', 'PK', 'VN', 'CN', 'NG', 'UA', 'RU',
        'IL', 'RO', 'TR', 'EE', 'VE',
        'DZ', 'AO', 'BJ', 'BW', 'BF', 'BI', 'CV', 'CM', 'CF', 'TD',
        'KM', 'CG', 'CD', 'CI', 'DJ', 'EG', 'GQ', 'ER', 'SZ', 'ET',
        'GA', 'GM', 'GH', 'GN', 'GW', 'KE', 'LS', 'LR', 'LY', 'MG',
        'MW', 'ML', 'MR', 'MU', 'MA', 'MZ', 'NA', 'NE', 'RW', 'ST',
        'SN', 'SC', 'SL', 'SO', 'ZA', 'SS', 'SD', 'TZ', 'TG', 'TN',
        'UG', 'ZM', 'ZW', 'EH', 'IO', 'RE', 'SH', 'YT'
      ]);
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 3500);

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(
          root + 'browsing_context_suggestions.json?country[enabled]=true',
          { credentials: 'same-origin', cache: 'no-store', signal: controller.signal }
        );
        if (!response.ok) return;
        const data = await response.json();
        const detected = data?.detected_values?.country?.handle;
        if (typeof detected !== 'string' || !denied.has(detected.toUpperCase())) return;

        const gate = source.content.firstElementChild.cloneNode(true);
        gate.addEventListener('cancel', event => event.preventDefault());
        document.body.appendChild(gate);
        gate.showModal();
        document.body.style.overflow = 'hidden';
        document.documentElement.dataset.acCountryGate = 'blocked';
      } catch {
        return;
      } finally {
        clearTimeout(timer);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
